export default "__VITE_ASSET__DSKAXVrc__"